import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { FarmCadastralSheetService } from '../_services';
import * as FarmCadastralSheetActions from '../_actions/farmCadastralSheet';

@Injectable({
  providedIn: 'root',
})
export class FarmCadastralSheetEffects {
  loadFarmCadastralSheets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmCadastralSheetActions.loadFarmCadastralSheets),
      mergeMap(() =>
        this.farmCadastralSheetService.getFarmCadastralSheets().pipe(
          map((farmCadastralSheets) =>
            FarmCadastralSheetActions.loadFarmCadastralSheetsSuccess({ farmCadastralSheets })
          ),
          catchError((error) =>
            of(FarmCadastralSheetActions.loadFarmCadastralSheetsFailure({ error }))
          )
        )
      )
    )
  );

  addFarmCadastralSheet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmCadastralSheetActions.addFarmCadastralSheet),
      mergeMap(({ farmCadastralSheet }) =>
        this.farmCadastralSheetService.saveFarmCadastralSheet(farmCadastralSheet).pipe(
          map((savedFarmCadastralSheet) =>
            FarmCadastralSheetActions.addFarmCadastralSheetSuccess({
              farmCadastralSheet: savedFarmCadastralSheet,
            })
          ),
          catchError((error) =>
            of(FarmCadastralSheetActions.addFarmCadastralSheetFailure({ error }))
          )
        )
      )
    )
  );

  updateFarmCadastralSheet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmCadastralSheetActions.updateFarmCadastralSheet),
      mergeMap(({ farmCadastralSheet }) =>
        this.farmCadastralSheetService.saveFarmCadastralSheet(farmCadastralSheet).pipe(
          map((updatedFarmCadastralSheet) =>
            FarmCadastralSheetActions.updateFarmCadastralSheetSuccess({
              farmCadastralSheet: updatedFarmCadastralSheet,
            })
          ),
          catchError((error) =>
            of(FarmCadastralSheetActions.updateFarmCadastralSheetFailure({ error }))
          )
        )
      )
    )
  );

  deleteFarmCadastralSheet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FarmCadastralSheetActions.deleteFarmCadastralSheet),
      mergeMap(({ id }) =>
        this.farmCadastralSheetService.deleteFarmCadastralSheet(id).pipe(
          map(() => FarmCadastralSheetActions.deleteFarmCadastralSheetSuccess({ id })),
          catchError((error) =>
            of(FarmCadastralSheetActions.deleteFarmCadastralSheetFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private farmCadastralSheetService: FarmCadastralSheetService
  ) {}
}
